import { render } from "./MobileAppLinkPopup.vue?vue&type=template&id=97a756ee&scoped=true&ts=true"
import script from "./MobileAppLinkPopup.vue?vue&type=script&lang=ts"
export * from "./MobileAppLinkPopup.vue?vue&type=script&lang=ts"

import "./MobileAppLinkPopup.vue?vue&type=style&index=0&id=97a756ee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a756ee"]])

export default __exports__